<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'SYSTEM',
          'UF_DOP_INFO'
        )
      }"
    >
      <textarea
        v-on:keyup="
          $parent.$parent.removeError('PROJECTS', 'SYSTEM', 'UF_DOP_INFO')
        "
        class="i-main-style t-dop-style i-wid-50"
        v-model="$parent.project.UF_DOP_INFO"
        :disabled="$parent.$parent.projectDisabled"
        style="height: 100px"
      ></textarea>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText("PROJECTS", "SYSTEM", "UF_DOP_INFO")
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UFDopInfo"
};
</script>

<style scoped></style>
